// extracted by mini-css-extract-plugin
export default {"section":"Ns-z","sectionTitle":"Os-z","fieldWrapper":"Ps-z","formField":"Qs-z","disabled":"Rs-z","formLabel":"Ss-z"};